import React, { useState } from 'react';
import Footer from '../../../components/Footer';
import VegIcon from '../../../components/VegIcon';
import OffersRenderer from '../../../components/OffersRenderer';
import './MidnightLuxe.css';

import DEFAULT_LOGO from '../../../assets/defaults/logo-default.jpg';
import DEFAULT_BG from '../../../assets/defaults/bg-default.jpg';
import DEFAULT_ITEM from '../../../assets/defaults/item-default.jpg';

const MidnightLuxe = ({ data }) => {
    const restaurant = data?.restaurant || {};
    const menus = data?.menus || [];
    const [activeMenuId, setActiveMenuId] = useState(menus[0]?.id);
    const [selectedItem, setSelectedItem] = useState(null);

    const activeMenu = menus.find(m => m.id === activeMenuId) || menus[0];

    if (!data) return <div className="luxe-loading">Loading Experience...</div>;

    return (
        <div className="luxe-container">
            <header className="luxe-header" style={{
                backgroundImage: `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.9)), url(${restaurant.backgroundImageUrl || DEFAULT_BG})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
            }}>
                <div className="luxe-brand">
                    <img src={restaurant.logoUrl || DEFAULT_LOGO} alt="Logo" className="luxe-logo" />
                    <h1 title={restaurant.name}>{restaurant.name || 'Luxe Dining'}</h1>
                    <div className="luxe-divider"></div>
                </div>
                <p className="luxe-desc" title={restaurant.description}>{restaurant.description || ''}</p>
            </header>

            {/* Offers / Notes */}
            <OffersRenderer offers={data?.offers} />

            {menus.length > 1 && (
                <nav className="luxe-nav">
                    {menus.map(menu => (
                        <button
                            key={menu.id}
                            className={`luxe-nav-item ${activeMenuId === menu.id ? 'active' : ''}`}
                            onClick={() => setActiveMenuId(menu.id)}
                        >
                            {menu.name}
                        </button>
                    ))}
                </nav>
            )}

            <main className="luxe-content">
                {activeMenu ? (
                    <div className="luxe-menu-fade">
                        <h2 className="luxe-menu-heading">{activeMenu.name}</h2>

                        {activeMenu.categories?.sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0)).map(category => (
                            <section key={category.id} className="luxe-category">
                                <h3 className="luxe-cat-header">{category.name}</h3>
                                <div className="luxe-items-list">
                                    {category.items?.map(item => (
                                        <LuxeItem key={item.id} item={item} onClick={() => setSelectedItem(item)} />
                                    ))}
                                </div>
                            </section>
                        ))}

                        {activeMenu.uncategorizedItems?.length > 0 && (
                            <section className="luxe-category">
                                <h3 className="luxe-cat-header">Specialties</h3>
                                <div className="luxe-items-list">
                                    {activeMenu.uncategorizedItems.map(item => (
                                        <LuxeItem key={item.id} item={item} onClick={() => setSelectedItem(item)} />
                                    ))}
                                </div>
                            </section>
                        )}
                    </div>
                ) : (
                    <div style={{ textAlign: 'center', padding: '50px', color: '#ccc' }}>
                        Menu details unavailable.
                    </div>
                )}
            </main>

            {selectedItem && (
                <div className="luxe-modal-overlay" onClick={() => setSelectedItem(null)}>
                    <div className="luxe-modal" onClick={e => e.stopPropagation()}>
                        <button className="luxe-modal-close" onClick={() => setSelectedItem(null)}>✕</button>
                        <div className="luxe-modal-img">
                            <img src={selectedItem.imageUrl || DEFAULT_ITEM} alt={selectedItem.name} />
                        </div>
                        <div className="luxe-modal-body">
                            <h3>{selectedItem.name}</h3>
                            <p className="luxe-modal-price">₹{(selectedItem.price || 0).toLocaleString()}</p>
                            <p className="luxe-modal-desc">{selectedItem.description}</p>

                            <div className="luxe-modal-variants">
                                <h4>Accompaniments</h4>
                                {selectedItem.variants?.filter(v => v.isActive).map(v => (
                                    <div key={v.id} className="luxe-v-row">
                                        <span>{v.name}</span>
                                        <span className="luxe-v-price">
                                            {v.price > 0 ? `₹${v.price.toLocaleString()}` : 'Included'}
                                        </span>
                                    </div>
                                ))}
                                {(!selectedItem.variants || selectedItem.variants.filter(v => v.isActive).length === 0) && (
                                    <p className="no-variants">No additional options available.</p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <Footer />
        </div>
    );
};

const LuxeItem = ({ item, onClick }) => {
    if (!item) return null;

    return (
        <div className={`luxe-item ${!item.isAvailable ? 'unavailable' : ''}`} onClick={onClick} style={{ cursor: 'pointer' }}>
            <div className="luxe-item-row">
                <div className="luxe-info">
                    <div className="luxe-head">
                        <div className="luxe-name-group">
                            {(item.isVeg !== undefined && item.isVeg !== null) && (
                                <span className={`luxe-veg-badge ${item.isVeg ? 'veg' : 'nonveg'}`}>
                                    <span className="luxe-veg-dot"></span>
                                </span>
                            )}
                            <span className="luxe-name" title={item.name}>{item.name}</span>
                        </div>
                        <span className="luxe-dots"></span>
                        <span className="luxe-price">₹{(item.price || 0).toLocaleString()}</span>
                    </div>

                    {/* Tags */}
                    {item.tags && item.tags.length > 0 && (
                        <div className="luxe-tags">
                            {item.tags.map(tag => (
                                <span key={tag} className="luxe-badge">{tag}</span>
                            ))}
                        </div>
                    )}

                    <p className="luxe-description" title={item.description}>{item.description}</p>
                </div>
                <div className="luxe-item-thumb">
                    <img src={item.imageUrl || DEFAULT_ITEM} alt={item.name} />
                </div>
            </div>
        </div>
    );
};

export default MidnightLuxe;
